export const NAV_LINKS = [
  { to: "/", label: "خانه" },
  { to: "/Expertise", label: "حیطه های فعالیت" },
  { to: "/ContactUs", label: "تماس با ما" },
];
